"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpatialAudioZone = exports.RemoteVoicePositionInfo = void 0;
class RemoteVoicePositionInfo {
}
exports.RemoteVoicePositionInfo = RemoteVoicePositionInfo;
class SpatialAudioZone {
}
exports.SpatialAudioZone = SpatialAudioZone;
